import '../../vendor/clickmenu.js';

(function ($) {
  $('.section-nav').clickMenu({
    expanders: 'true',
  });
})(window.jQuery);
